import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext } from "@tanstack/react-router";

import RootLayout from "@/app/layout";
import NotFound from "@/app/not-found";
import RouteError from "@/app/route-error";
import { rootHead } from "@/lib/head";

export interface RouterContext {
  queryClient: QueryClient;
}

// 배치 슬롯 파일은 이 route 나 다른 슬롯의 route 를 getParentRoute 로 가리킨다 · head 기본값은 legacy 루트 metadata(고객 화면은 끊는다).
export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  head: ({ matches }) => rootHead(matches),
  errorComponent: RouteError,
  notFoundComponent: NotFound,
});
